// ─── The filter list behind a built metric ────────────────────────────────────
// Pure, no React — used by the alert editor (and testable, which the JSX isn't).
//
// A built metric carries ONE list of filters, and the EVENT is one of them. But
// the event has its own picker at the top of the form, so the "Filter (optional)"
// rows below must hide it — and that hiding is where this went wrong.
//
// The list was rendered as `filters.filter(notTheEvent).map((f, i) => …)` and `i`
// was handed straight to a setter that indexed the UNFILTERED array. The event is
// PREPENDED when you choose it, so the first filter row was position 0 in both
// lists: picking "Ticket Type" wrote over filters[0] — the event — which blanked
// it and let the default-pin effect quietly re-pick the suite's own event. To the
// person filling the form, choosing a ticket type reverted the event they had
// just set (reported 2026-08-27). The ✕ on that row deleted the event outright.
//
// So the index is carried WITH the row (`visibleFilters` → `.i`), and the setters
// additionally refuse to touch the event whatever index they are given. One of
// those two would fix it; both together mean a future off-by-one is a no-op
// instead of a silently wrong metric.

// The rows to SHOW, each carrying its real index in the source list as `.i`.
export function visibleFilters(filters, eventField) {
  return (filters || []).map((f, i) => ({ ...f, i })).filter((f) => !eventField || f.field !== eventField);
}
// Patch one row. `i` is the index in `filters`, never the position on screen.
export function setFilterAt(filters, i, patch, eventField) {
  return (filters || []).map((f, j) => (j === i && !isEvent(f, eventField) ? { ...f, ...patch } : f));
}
// Remove one row. The event is never removable from here — it is cleared by
// setting its own picker back to blank.
export function removeFilterAt(filters, i, eventField) {
  return (filters || []).filter((f, j) => j !== i || isEvent(f, eventField));
}
const isEvent = (f, eventField) => !!eventField && f && f.field === eventField;
